import React from 'react';

import { FormattedMessage } from 'react-intl';

import MegaphoneIcon from '@atlaskit/icon/core/megaphone';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Flex } from '@atlaskit/primitives/components/flex';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Pressable } from '@atlaskit/primitives/pressable';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

import { useProductDependencies } from '../../../controllers/use-product-dependencies';
import { type FeedbackType } from '../../../types';
import { messages } from './messages';

const buttonContentWrapperStyles = xcss({
	height: '20px',
});

const buttonStyles = xcss({
	width: '100%',
	borderRadius: 'radius.small',
	backgroundColor: 'color.background.neutral.subtle',
	borderWidth: 'border.width',
	borderStyle: 'solid',
	borderColor: 'color.border',
	color: 'color.text',
	paddingInline: 'space.200',
	paddingBlock: 'space.050',
	alignItems: 'center',
	':hover': {
		cursor: 'pointer',
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- the rule does not yet recognise @atlaskit/primitives subpath entry points
		backgroundColor: 'color.background.accent.gray.subtlest.hovered',
	},
	':active': {
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- the rule does not yet recognise @atlaskit/primitives subpath entry points
		backgroundColor: 'color.background.accent.gray.subtlest.pressed',
	},
});

interface ConfigPanelFeedbackCollectorProps {
	source: string;
	type: FeedbackType;
}

export const ConfigPanelFeedbackCollector = ({
	source,
	type,
}: ConfigPanelFeedbackCollectorProps): React.JSX.Element | null => {
	const { useFeedbackCollector } = useProductDependencies();
	const openFeedbackCollector = useFeedbackCollector?.({ source, type });

	// Feedback button won't render if it isn't provided in the product dependencies
	if (!useFeedbackCollector) {
		return null;
	}

	return (
		<Pressable
			xcss={buttonStyles}
			onClick={openFeedbackCollector}
			testId="feedback-collector-button"
		>
			<Flex
				alignItems="center"
				justifyContent="center"
				gap="space.100"
				xcss={buttonContentWrapperStyles}
			>
				<MegaphoneIcon label="" />
				{/* replacing whitespace from type is necessary, because there are FeedbackTypes that are
				whitespaced. i18n selects do not validate options with whitespace as in i18n.shareFeedbackButtonTextExtension
				above */}
				<FormattedMessage
					{...messages.shareFeedbackButtonTextExtension}
					values={{ type: type.replace(/\s/g, '') }}
				/>
			</Flex>
		</Pressable>
	);
};
